<template>
  <sui-segment>
    <h2 is="sui-header" dividing>
      {{ $t("settings") }}
    </h2>
    <sui-segment>
      <sui-form equal-width>
        <h3>{{ $t("changename") }}</h3>
        <sui-form-fields :fields="2">
          <sui-form-field>
            <label>{{ $t("firstname") }}:</label>
            <sui-input placeholder="Max" v-model="current.firstname" />
          </sui-form-field>
          <sui-form-field>
            <label>{{ $t("lastname") }}:</label>
            <sui-input placeholder="Mustermann" :value="current.lastname" />
          </sui-form-field>
        </sui-form-fields>
          <sui-dimmer :active="nameloading">
            <sui-loader>{{ $t("loading") }}</sui-loader>
          </sui-dimmer>
      </sui-form>
      <sui-button
        class="ui red fluid approve button"
        @click="clickChangeName"
        >{{ $t("save") }}</sui-button
      >
    </sui-segment>
    <br />
  <sui-segment v-if="isAdmin">
      <sui-form equal-width>
        <h3>{{ $t("getNotifications") }}</h3>
          <sui-form-field>
            <v-checkbox placeholder="Max" v-model="current.notifications" :label="$t('getEmailNotifications')"></v-checkbox>
          </sui-form-field>
          <sui-dimmer :active="notiloading">
            <sui-loader>{{ $t("loading") }}</sui-loader>
          </sui-dimmer>
      </sui-form>
      <sui-button
        class="ui red fluid approve button"
        @click="clickChangeNotis"
        >{{ $t("save") }}</sui-button
      >
  </sui-segment>
    <br />
    <sui-segment>
      <sui-form equal-width>
        <h3>{{ $t("changeDetails") }}</h3>
        <sui-form-fields :fields="2">
          <sui-form-field>
            <label>{{ $t("email") }}:</label>
            <sui-input placeholder="m.mustermann@beispiel.de" v-model="current.email" />
          </sui-form-field>
          <sui-form-field>
            <label>{{ $t("phone") }}:</label>
            <sui-input placeholder="+49 0123 456789" v-model="current.phone" />
          </sui-form-field>
        </sui-form-fields >
        <sui-form-fields :fields="2">
          <sui-form-field>
            <label>{{ $t("company") }}:</label>
            <sui-input placeholder="..." :value="current.company" />
          </sui-form-field>
          <sui-form-field>
            <label>{{ $t("gender") }}:</label>  
              <sui-dropdown
                  :placeholder="$t('gender')"
                  selection
                  :options="options"
                  v-model="current.gender"
                    />    
          </sui-form-field>
        </sui-form-fields >
          <sui-dimmer :active="detailsloading">
            <sui-loader>{{ $t("loading") }}</sui-loader>
          </sui-dimmer>
      </sui-form>
      <sui-button
        class="ui red fluid approve button"
        @click="clickChangeDetails"
        >{{ $t("save") }}</sui-button
      >
    </sui-segment>
    <br />
    <sui-segment>
      <sui-form equal-width>
        <h3>{{ $t("changepassword") }}</h3>
        <sui-form-field required>
          <label>{{ $t("password") }}</label>
          <sui-input
            placeholder="..."
            type="password"
            v-model="oldpassword"
          />
        </sui-form-field>
        <sui-form-fields :fields="2">
          <sui-form-field required>
            <label>{{ $t("newpassword") }}</label>
            <sui-input
              placeholder="..."
              type="password"
              name="newpassword"
              v-model="password"
            />
          </sui-form-field>
          <sui-form-field required>
            <label>{{ $t("passwordAgain") }}</label>
            <sui-input
              placeholder="..."
              type="password"
              name="confirmnewpassword"
              v-model="password_confirmation"
            />
          </sui-form-field>
          <br />
        </sui-form-fields>
          <sui-dimmer :active="passloading">
            <sui-loader>{{ $t("loading") }}</sui-loader>
          </sui-dimmer>
      </sui-form>
      <sui-button fluid color="red" @click.prevent="updatePassword">{{
        $t("save")
      }}</sui-button>
    </sui-segment>
    <br>
  </sui-segment>
</template>
<script>
import ApiService from "@/services/ApiService.js";
  import Permission from '@/services/PermissionService.js';
  import Validator from '@/services/PasswordService.js';
  
export default {
  name: "Settings",
  data() {
    return {
      stats: {},
      current: {
        gender: 0,
      },
      mode: "general",
      oldpassword: "",
      password_confirmation: "",
      password: "",
      id: 0,
      isAdmin: false,
      errorpass: false,
      passloading: false,
      notiloading: false,
      errorpassmsg: "",
      userID: 0,
      output_format: null,
      detailsloading: false,
      nameloading: false,
      updateTable: 0,
      options: [{
        value: "2",
        text: this.$t("female")
      },{
        value: "1",
        text: this.$t("male")
      },{
        value: "3",
        text: this.$t("nonBinary")
      }],
      urls: {
        output: ApiService.getApiUrl() + "dropdown/output_format"
      }
    };
  },
  async created() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push("/login");
    } else {
      this.userRole = this.$store.getters.getRole;
    }
    if(!Permission.checkPermission("view self")){
      //TODO
    } else {
      this.renderContent();
    }
    this.isAdmin = Permission.checkPermission("get checkout notification", false);
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
    async renderContent() {
      this.id = this.$store.getters.userId;
      this.current.firstname = this.$store.getters.user.firstname;
      this.current.lastname = this.$store.getters.user.lastname;
      this.current.phone =this.$store.getters.user.phone;
      this.current.company =this.$store.getters.user.company;
      this.current.gender =this.$store.getters.user.gender;
      this.current.email =this.$store.getters.user.email;
      this.current.notifications =this.$store.getters.user.notifications;
      let res= await ApiService.getUser(this.id)
      this.current = res.data
        this.updateTable++;
    },
    async clickChangeName() {
      if(Permission.checkPermission("edit self", false)){
          let response = null;
          this.nameloading = true;
          response = await ApiService.putUpdateSelf({firstname: this.current.firstname, lastname: this.current.lastname});
          this.nameloading = false;
          if (response.status == 200) {
            this.$store.dispatch("setUser", response.data)
            this.$swal({
              icon: 'success',
              title: this.$t("yea"),
              text: this.$t("saved"),
            }).then(async () => {
              // Zeige Seite
              this.renderContent();
            });
          }
      }
    },
    async updateStore(user){
      this.$store.dispatch('setUser', user);
    },
  async clickChangeDetails(){
      if(Permission.checkPermission("edit self", false)){
      if (this.current.phone != null || this.current.company != null || this.current.gender != null || this.current.email != null) {
        this.detailsloading = true;
          let response = await ApiService.putUpdateSelf({
            phone: this.current.phone,
            company: this.current.company,
            gender: this.current.gender,
          });
          this.detailsloading = false;
       if(response.status != 200) return this.popup("error",response.data.error);
       this.popup("success", "saved")
      this.updateStore(response.data)
      }
      }
  },
    async updatePassword() {
      if(Permission.checkPermission("edit self", false)){
      this.passloading = true;
      this.errorpass =
        !(this.password == this.password_confirmation) ||
        !(this.password && this.password.length > 0);
      this.errorpassmsg = this.errorpass ? this.$t("errorpass") : "";
      if (this.errorpass == false) {
        if(Validator.checkPassword(this.password)){ return this.popup("error","passwordInsecure") }

          let response = await ApiService.putUpdateSelf({
            oldpassword: this.oldpassword,
            password_confirmation: this.password_confirmation,
            password: this.password
          });
       if(response.status != 200) return this.popup("error",response.data.error);
       this.updateStore(response.data)
       this.popup("success", "saved")
      }else{
       return this.popup("error", "errorPassDefault")
      }
      }
    },
  // SystemTest123!!
    popup(type, reason){
        this.passloading = false;
        this.$swal({
            icon: type,
            title: this.$t(type),
            text: this.$t(reason),
          })
        return;
    },
    async clickChangeNotis(){
      this.notiloading = true
      let res = await ApiService.putUpdateSelf({
        notifications: this.current.notifications
      })
      if(res.status == 200){
        this.renderContent()
      }
      this.notiloading = false
    },
    async old_applypassword() {
      if(Permission.checkPermission("edit self", false)){
      this.passloading = true;
      this.errorpass =
        !(this.password == this.password_confirmation) ||
        !(this.password && this.password.length > 0);
      this.errorpassmsg = this.errorpass ? this.$t("errorpass") : "";
      if (this.errorpass == false) {
        if(!Validator.checkPassword(this.password)){
        this.passloading = false;
        this.current.id = this.id;
        let response = await ApiService.postLogin({
          email: this.$store.getters.user.email,
          password: this.oldpassword,
        });
        if (response.status == 200) {
          response = await ApiService.putUser({
            id: response.data.user.id,
            password: this.password
          });
          {
            if (response.status == 200) {
              (this.password = ""),
                (this.password_confirmation = ""),
                (this.oldpassword = ""),
       this.updateStore(response.data)
                this.$swal({
                  title: this.$t("yea"),
                  text: this.$t("saved"),
                  icon: "success",
                });
            } else {
              this.passloading = false;
              this.$swal({
              icon: 'error',
                title: this.$t("error"),
                text: this.$t(response.data.error),
              });
            }
          }
        } else {
              this.passloading = false;
              this.$swal({
              icon: 'error',
                title: this.$t("error"),
                text: this.$t("wrongpass"),
              });
            }
          
        }else{
        this.passloading = false;
          this.$swal({
              icon: 'error',
              title: this.$t("error"),
              text: this.$t("passwordInsecure"),
            })
          return;
        }
      } else {
        this.passloading = false;
              this.$swal({
              icon: 'error',
                title: this.$t("error"),
                text: this.$t("errorDefault"),
              });
      }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
